__turbopack_context__.v({
  "brands": "style-module-scss-module__KLNL2a__brands",
  "img": "style-module-scss-module__KLNL2a__img",
  "item": "style-module-scss-module__KLNL2a__item",
  "link": "style-module-scss-module__KLNL2a__link",
  "list": "style-module-scss-module__KLNL2a__list",
  "title": "style-module-scss-module__KLNL2a__title",
});
